<template>
    <b-modal
            v-model="visible"
            title="افزودن فایل"
            ok-title="ذخیره"
            cancel-title="انصراف"
            cancel-variant="outline-secondary"
            centered
            :no-close-on-backdrop="true"
            size="md"
            @ok="save"
    >
        <b-form @submit.prevent>
            <b-row>
                <b-col cols="6">
                    <v-select
                        v-model="form.Type"
                        :options="galleryTypes"
                        dir="rtl"
                        placeholder="نوع فایل"
                        label="text"
                        :reduce="x => x.value"
                        :clearable="true"
                    />
                </b-col>
                <b-col cols="6">
                    <upload-media
                        v-if="form.Type && enums('heroGalleryType', 'value', form.Type, 'type') === 'video'"
                        v-model="form.File"
                        accept=".mp4,.mov,.wmv"
                        icon="FilmIcon"
                        label="انتخاب ویدئو"
                    />
                    <upload-media
                        v-else
                        v-model="form.File"
                        icon="ImageIcon"
                        label="انتخاب عکس"
                    />
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import uploadFile from "@/tools/uploadFile.vue";
import uploadMedia from "@/tools/media/uploadMedia.vue";

export default {
    name: "heroAddFileGallery",
    components: {uploadFile, uploadMedia},
    props: {
        show:{ type: Boolean, default: false }
    },
    data() {
        return {
            loading: false,
            form: {
                File: null,
                UserId: this.$route.params.id,
                Type: null
            }
        }
    },
    computed: {
        galleryTypes() {
          return [
            this.enums('heroGalleryType', 'key', 'ImageGalleryBefore'),
            this.enums('heroGalleryType', 'key', 'ImageGalleryAfter'),
            this.enums('heroGalleryType', 'key', 'Video')
          ]
        },
        visible: {
            get() {
                return this.show
            },
            set(val) {
                return this.$emit('update:show', !!val)
            }
        }
    },
    methods: {
        save() {
            let url = this.$api.hero.addGalleryHero

            const formData = new FormData()
            formData.append('File', this.form.File)
            formData.append('Type', this.form.Type)
            formData.append('UserId', this.form.UserId)

            this.loading = true
            this.$http.post(url, formData)
                .then(response => {
                  this.$emit('add', response.data)
                    this.loading = false
                })
                .finally(() => {
                    this.loading = false
                })
        },
    }
}
</script>